const es = {
  pleaseEnterUsername: "Por favor, introduce un nombre de usuario",
  cannotFriendYourself: "No puedes enviarte una solicitud de amistad a ti mismo.",
  friendRequestSent: "¡Solicitud de amistad enviada!",
  failedToSendRequest: "No se pudo enviar la solicitud",
  linkCopied: "¡Enlace copiado al portapapeles!",
  backToInvites: "Volver a invitaciones",
  sendFriendRequestByUsername: "Enviar solicitud de amistad por nombre de usuario",
  enterUsername: "Introduce un nombre de usuario",
  send: "Enviar",
  yourInviteQrCode: "Tu código QR de invitación",
  inviteLink: "Enlace de invitación",
  scanQrOrUseLink: "Escanea este código QR o utiliza este enlace para enviar una solicitud de amistad",
  copyInviteLink: "Copiar enlace de invitación",
  goToItem: "Ir al elemento",
  verificationEmailSent: "¡Correo de verificación enviado! Revisa tu bandeja de entrada.",
  verificationEmailFailed: "No se pudo enviar el correo de verificación. Inténtalo de nuevo.",
  verifyYourEmail: "Verifica tu correo electrónico",
  verifyEmailInstructions: "Por favor, verifica tu dirección de correo electrónico para acceder a tu cuenta. Revisa tu bandeja de entrada para encontrar el enlace de verificación.",
  sending: "Enviando...",
  resendVerificationEmail: "Reenviar correo de verificación",
  login: "Iniciar sesión",
  register: "Registrarse",
  home: "Inicio",
  calendar: "Calendario",
  friends: "Amigos",
  profile: "Perfil",
  logout: "Cerrar sesión",
  loading: "Cargando...",
  language: "Idioma",
  calendarSelectPlaceSuggestion: "Por favor, selecciona un lugar de las sugerencias para adjuntar las coordenadas.",
  calendarSelectDateAndTime: "Por favor, selecciona una fecha y una hora.",
  calendarPositiveDuration: "Por favor, introduce una duración positiva.",
  calendarFutureDateRequired: "La fecha y hora del evento deben estar en el futuro.",
  calendarCreateEventFailed: "No se pudo crear el evento. Inténtalo de nuevo.",
  cancel: "Cancelar",
  createNewEvent: "Crear nuevo evento",
  week: "Semana",
  month: "Mes",
  eventTitle: "Título",
  date: "Fecha",
  time: "Hora",
  duration: "Duración",
  endsAt: "Termina a las",
  place: "Lugar",
  searchForPlace: "Buscar un lugar",
  placeSearchTip: "Consejo: comienza a escribir y selecciona un resultado para adjuntar coordenadas.",
  description: "Descripción",
  createEvent: "Crear evento",
  today: "Hoy",
  previousMonth: "Mes anterior",
  nextMonth: "Mes siguiente",
  previous: "Anterior",
  next: "Siguiente",
  mondayShort: "Lun",
  tuesdayShort: "Mar",
  wednesdayShort: "Mié",
  thursdayShort: "Jue",
  fridayShort: "Vie",
  saturdayShort: "Sáb",
  sundayShort: "Dom",
  more: "más",
  mustRespondWillBeforeReposting: "Debes responder «Asistiré» antes de volver a publicar",
  event: "Evento",
  backToCalendar: "Volver al calendario",
  addToGoogleCalendar: "Añadir a Google Calendar",
  when: "Cuándo",
  where: "Dónde",
  openLocationInGoogleMaps: "Abrir ubicación en Google Maps",
  hosts: "Organizadores",
  yourResponse: "Tu respuesta",
  currentResponse: "Respuesta actual",
  response_will: "Asistiré",
  response_might: "Puede que asista",
  response_wont: "No asistiré",
  willRunIntoYou: "Me pasaré",
  mightDropBy: "Puede que me pase",
  wontCome: "No iré",
  repostToMyFriends: "Compartir con mis amigos",
  responses: "Respuestas",
  willAttend: "Asistirá",
  reposted: "Compartido",
  mightAttend: "Puede que asista",
  cancelEvent: "Cancelar evento",
  cancellationEmailNoticeBefore: "Las personas que indicaron que asistirán",
  cancellationEmailNoticeAfter: "recibirán un correo electrónico notificando la cancelación.",
  optionalCancellationMessage: "Mensaje opcional para los asistentes (máximo 1000 caracteres)",
  confirmCancelEvent: "Confirmar cancelación del evento",
  clear: "Limpiar",
  confirmCancellation: "Confirmar cancelación",
  confirmCancellationMessage: "¿Seguro que quieres cancelar este evento? Esto notificará a los asistentes confirmados y eliminará el evento.",
  eventCancelledNotified: "Evento cancelado. Notificados",
  attendees: "asistentes",
  failedToCancelEvent: "No se pudo cancelar el evento",
  back: "Atrás",
  cancelled: "Cancelado",
  ok: "Aceptar",
  forgotPassword: "Olvidé mi contraseña",
  email: "Correo electrónico",
  passwordResetLinkSent: "Si la cuenta existe, se ha enviado un enlace para restablecer la contraseña.",
  passwordResetRequestFailed: "No se pudo solicitar el restablecimiento de la contraseña.",
  sendResetLink: "Enviar enlace de restablecimiento",
  addFriend: "Añadir amigo",
  incomingRequests: "Solicitudes recibidas",
  accept: "Aceptar",
  deny: "Rechazar",
  myFriends: "Mis amigos",
  noFriendsYet: "Todavía no tienes amigos. ¡Empieza a añadir algunos!",
  seeProfile: "Ver perfil",
  noEventsToRespondTo: "No hay eventos a los que responder",
  allCaughtUp: "Ya estás al día. Vuelve más tarde para ver nuevos eventos de tus amigos.",
  events: "Eventos",
  unknown: "Desconocido",
  noDescriptionProvided: "No se proporcionó descripción.",
  will: "Sí",
  maybe: "Quizás",
  wont: "No",
  userNotFound: "Usuario no encontrado",
  friendRequestSentSuccessfully: "¡Solicitud de amistad enviada correctamente!",
  friendInvitation: "Invitación de amistad",
  sendFriendRequest: "Enviar solicitud de amistad",
  loginToSendFriendRequest: "Por favor, inicia sesión para enviar una solicitud de amistad",
  chooseLanguage: "Elegir idioma",
  invalidCredentials: "Credenciales no válidas. Inténtalo de nuevo.",
  username: "Nombre de usuario",
  password: "Contraseña",
  forgotPasswordQuestion: "¿Olvidaste tu contraseña?",
  dontHaveAccount: "¿No tienes una cuenta?",
  registerHere: "Regístrate aquí",
  invalidProfilePhotoType: "Tipo de archivo no válido. Sube una imagen JPEG, PNG, GIF o WebP.",
  invalidFileExtension: "Extensión de archivo no válida",
  allowedExtensions: "Permitidas",
  fileTooLarge: "Archivo demasiado grande",
  maximumFileSize: "Máximo",
  profilePhotoRemoved: "Foto de perfil eliminada.",
  failedToRemoveProfilePhoto: "No se pudo eliminar la foto de perfil",
  profileUpdatedSuccessfully: "¡Perfil actualizado correctamente!",
  failedToUpdateProfile: "No se pudo actualizar el perfil",
  privateEmailExplanation: "Solo tú puedes ver tu correo electrónico para evitar mensajes no deseados fuera de la plataforma",
  yourEmailIsPrivate: "Tu correo electrónico es privado.",
  profilePhoto: "Foto de perfil",
  removePhoto: "Eliminar foto",
  firstName: "Nombre",
  lastName: "Apellido",
  tellPeopleAboutYourself: "Cuéntales a los demás sobre ti",
  whereToContactMe: "Dónde contactarme",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "Guardar",
  notSet: "No establecido",
  editProfile: "Editar perfil",
  imageToCrop: "Imagen para recortar",
  zoom: "Zoom",
  usePhoto: "Usar foto",
  name: "Nombre",
  whereToContact: "Contacto",
  removeFriendship: "Eliminar amistad",
  confirmRemoveFriend: "Confirmar eliminación del amigo",
  confirmRemoveFriendBefore: "¿Seguro que quieres eliminar a",
  confirmRemoveFriendAfter: "de tu lista de amigos?",
  friendRemoved: "Amigo eliminado.",
  failedToRemoveFriend: "No se pudo eliminar al amigo.",
  confirmRemove: "Confirmar eliminación",
  error: "Error",
  removed: "Eliminado",
  passwordsDoNotMatch: "Las contraseñas no coinciden",
  registrationFailed: "El registro ha fallado. Inténtalo de nuevo.",
  confirmPassword: "Confirmar contraseña",
  alreadyHaveAccount: "¿Ya tienes una cuenta?",
  loginHere: "Inicia sesión aquí",
  passwordResetSuccessfully: "Contraseña restablecida correctamente.",
  failedToResetPassword: "No se pudo restablecer la contraseña.",
  resetPassword: "Restablecer contraseña",
  newPassword: "Nueva contraseña",
  confirmNewPassword: "Confirmar nueva contraseña",
  setNewPassword: "Establecer nueva contraseña",
  emailVerifiedSuccessfully: "¡Correo electrónico verificado correctamente!",
  emailVerificationFailed: "La verificación ha fallado. El enlace puede ser inválido o haber expirado.",
  verifying: "Verificando...",
  verified: "¡Verificado!",
  redirectingToHome: "Redirigiendo al inicio...",
  verificationFailed: "Verificación fallida",
  goToHome: "Ir al inicio",
  about: "Acerca de",
  aboutConceptTitle: "Concepto",
  aboutCreatorIntroduction: "Hola, soy Crypt0, escalador y creador de Run Into Me.",
  aboutCreatorStory: "Creé este sitio porque soy muy sociable y, entre dos vías, no puedo evitar hablar con otros escaladores. Terminé guardando demasiados números y dedicando demasiado tiempo libre a organizar sesiones.",
  aboutPlanningProblem: "Me cansé de planificar cada sesión y escribir a cada amigo por separado; quería avisar a todos a la vez de cuándo y dónde iba a escalar, sin invitaciones formales.",
  aboutDeveloperSolution: "Entonces recordé que soy desarrollador y podía crear la solución yo mismo.",
  aboutWelcome: "Bienvenido a Run Into Me, un sitio para informar a tus amigos de actividades a las que pueden unirse sin presión.",
  aboutCallToAction: "La próxima vez que planees una actividad que puedas hacer solo pero sea más divertida en grupo, publícala aquí para tus amigos.",
  aboutTutorialTitle: "Tutorial",
  aboutCalendarCreateEvent: "La pantalla Calendario también permite crear un evento nuevo.",
  aboutEventColorsIntroduction: "Los colores indican tu estado de participación:",
  aboutColorGold: "Dorado",
  aboutColorGoldDescription: "Organizas este evento.",
  aboutColorGreen: "Verde",
  aboutColorGreenDescription: "Asistes a este evento.",
  aboutColorOrange: "Naranja",
  aboutColorOrangeDescription: "Respondiste «quizá».",
  aboutColorBlue: "Azul",
  aboutColorBlueDescription: "Aún no has respondido.",
  aboutColorGray: "Gris",
  aboutColorGrayDescription: "Rechazaste la invitación.",
  aboutCalendarEventDetails: "Haz clic en un evento para obtener más información y responder.",
  aboutFriendPageTitle: "Página de amigos",
  aboutFriendPageDescription: "Para añadir un amigo, introduce su usuario o envíale tu enlace de invitación / código QR.",
  aboutHomePageTitle: "Página de inicio",
  aboutHomePageDescription: "Consulta los próximos eventos de tus amigos e indica si asistirás.",
  aboutRepostScreenTitle: "Pantalla de republicación",
  aboutGoogleCalendarDescription: "Usa este botón para añadir el evento a Google Calendar.",
  aboutRepostDescription: "Después de confirmar tu asistencia, puedes republicar el evento para tus amigos.",
};

export default es;